let cachedTimezone = null;

export function setCachedTimezone(tz) {
  cachedTimezone = tz;
}

export function formatDateTime(dateStr, options = {}) {
  if (!dateStr) return "";
  const tz = cachedTimezone || "Asia/Kolkata";
  try {
    return new Intl.DateTimeFormat("en-IN", {
      timeZone: tz,
      dateStyle: options.dateStyle || "medium",
      timeStyle: options.timeStyle,
    }).format(new Date(dateStr));
  } catch {
    return new Date(dateStr).toLocaleString();
  }
}

// Returns YYYY-MM-DD using the LOCAL calendar date (no UTC shift).
// date.toISOString() shifts to UTC which is wrong for positive-offset
// timezones like IST - e.g. selecting "5 Jul" at midnight IST would
// serialize to "2026-07-04" via toISOString(), a day off.
export function toLocalDateString(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
